<template>
    <section class="content">
        <div class="box box-info">
            <div class="box box-body">
              <div id="billNo"  class="col-sm-3">
                  <label for="billNo">Assign No :</label>
                  <span  class="purchaseOutput "><b>{{purchaseHeaderObj.assignNo}}</b></span>
              </div>
               <div id="purchaseDate" class="col-sm-3" style="margin-left: -8%;">
                  <label for="purchaseDate" >Assign From :</label>
                  <span class="purchaseOutput"><b>{{purchaseHeaderObj.assignFromDate}}</b></span>
               </div>
               <div id="purchaseDate1" class="col-sm-3 " style="margin-left: -5%;">
                    <label for="purchaseDate1" >Assign To :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.assignToDate}} </b>
                    </span>
               </div>
                <div id="warehouseName" class="col-sm-3 " style="margin-left: -5%;">
                    <label for="WarehouseName" >Store :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.warehouse.name}} </b>
                    </span>
               </div>
               <div id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Employee :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.employee.name}}</b>
                    </span>
               </div>
               <div id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Contact :</label>
                    <span class="purchaseOutput ">
                      <b></b>
                    </span>
               </div>
                <div  id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Address :</label>
                    <span class="purchaseOutput ">
                      <b></b>
                    </span>
               </div>

           <table class="table table-bordered " style="margin-top: 5%;">
            <thead >
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Item Name</th>
                <th scope="col">Quantity</th>
                <!-- <th>Action</th> -->
              </tr>
            </thead>
            <tbody  v-for="(pd,index) in assignDetailList " :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{pd.name}}</td>
                <td>{{pd.quantity}}</td>
              </tr>
            </tbody>
          </table>
           <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <textarea type="text" rows="6" class="form-control"  v-model="purchaseHeaderObj.remarks"/>
         </div>
       <div class="box-footer" style="margin-top: 12%;">
          <!-- <Button class="p-button-raised p-button-warning" icon="pi pi-refresh" style="margin-top: 10px;float: right;margin-left: 100%;"  @click.prevent="$router.back()">Back</Button> -->
      <Button   @click.prevent="$router.back()" class="p-button-raised" style="margin-top: 10px;float: right;margin-left: 100%;" icon="pi pi-refresh" label="Back"/>
      </div>
   </div>
        </div>
    </section>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
export default {
  name: 'purchaseDetailReport',
  props: ['purchaseHeaderObj'],
  data() {
    return {
      assignDetailList: []
    }
  },
  created() {
    this.searchInventoryInDetail()
  },
  methods: {
    async searchInventoryInDetail() {
      if (this.purchaseHeaderObj === undefined) {
        this.$router.back()
        return
      }
      let resp = await this.$store.dispatch('loadInventoryAssignDetail', this.purchaseHeaderObj.id)
      if (resp.data.status === 'SUCCESS') {
        this.assignDetailList = resp.data.data
      }
    },
    cancel() {
      this.showPosDialog = false
    }
  },
  components: {
    Button,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// assignDetails.vue?2c14060c